import { notification } from "antd";
import { useMutation, useQuery } from "react-query";
import { GET, POST } from "../../../../Services";

export const useObjetosUsuariosTable = (params = null) => {
    return useQuery(
        ["objetosUsuariosTable", params],
        async () => {
            const response = await GET(
                "usuarios/objetosUsuariosTable",
                `?${new URLSearchParams(params).toString()}`
            );
            if (response.length == 0) {
                throw new Error("Error al cargar la tabla de objetos");
            }
            return response;
        },
        {
            retry: 0,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            onError: (error) => {
                notification["error"]({
                    message: "Error intentando cargar la tabla de objetos",
                });
            },
        }
    );
};

export const useObtenerObjetoUsuario = () => {
    return useMutation(async (data) => await POST(data, "objeto/agregarObjetoUsuario"), {
        onSuccess: () => {
            notification["success"]({ message: "objeto otorgador correctamente" });
        },
        onError: (error) => {
            if (error.response && error.response.data?.mensaje) {
                notification["error"]({ message: error.response.data.mensaje });
            } else {
                notification["error"]({ message: "Error al obtener logro para el usuario" });
            }
        },
    });
};

export const useEditarObjetoUsuario = () => {
    return useMutation(async (data) => await POST(data, "objeto/editarObjetosUsuario"), {
        onSuccess: () => {
            notification["success"]({ message: "Objeto de usuario editado correctamente" });
        },
        onError: (error) => {
            if (error.response && error.response.data?.mensaje) {
                notification["error"]({ message: error.response.data.mensaje });
            } else {
                notification["error"]({ message: "Error al editar objeto del usuario" });
            }
        },
    });
};

export const useEliminarObjetoUsuario = () => {
    return useMutation(async (data) => {
        const payload = {
            idUsuario: data.usua_id,
            idObjeto: data.idObjeto,
            idObjetoObtenido: data.idObjetoUsuario,
            forzar: false
        };
        return await POST(payload, "objeto/eliminarObjetoUsuario");
    }, {
        onSuccess: () => {
            notification["success"]({ message: "Objeto eliminado del usuario correctamente" });
        },
        onError: (error) => {
            if (error.response && error.response.data?.mensaje) {
                notification["error"]({ message: error.response.data.mensaje });
            } else {
                notification["error"]({ message: "Error al eliminar objeto del usuario" });
            }
        },
    });
};

export const useEliminarTotalObjetoUsuario = () => {
    return useMutation(async (data) => {
        const payload = {
            idUsuario: data.usua_id,
            idObjeto: data.idObjeto,
            idObjetoObtenido: data.idObjetoUsuario,
            forzar: true
        };
        return await POST(payload, "objeto/eliminarObjetoUsuario");
    }, {
        onSuccess: () => {
            notification["success"]({ message: "Objeto eliminado totalmente" });
        },
        onError: (error) => {
            if (error.response && error.response.data?.mensaje) {
                notification["error"]({ message: error.response.data.mensaje });
            } else {
                notification["error"]({ message: "Error al eliminar objeto del usuario" });
            }
        },
    });
};